export const WhatsNew = 'WhatsNew/';

export const GetAll = WhatsNew + 'GetAll';
